module.exports = __webpack_public_path__ + "assets/white_cart-4ca80b.svg";